import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class EmailTplDataService {
	public constructor(
		private api: ApiService
	) {}

	// CRUD
	public list = () => this.api.sendApiRequest('get', 'emailtpl/datatables').toPromise();
	public create = (data: any) => this.api.sendApiRequest('post', 'emailtpl', data).toPromise();
	public view = (id: string|number) => this.api.sendApiRequest('get', `emailtpl/${id}`).toPromise();
	public edit = (id: string|number, data: any) => this.api.sendApiRequest('put', `emailtpl/${id}`, data).toPromise();
	
	public delete = (id: string|number) => this.api.sendApiRequest('delete', `emailtpl/${id}`).toPromise();
}


// WEBPACK FOOTER //
// ./src/services/data.emailtpls.service.ts